import { Loader2 } from "lucide-react"

export function AuthPageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30">
      <Loader2 className="size-6 animate-spin text-muted-foreground" />
    </div>
  )
}
